import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchasePoDetailsModel } from "./purchasePoDetailsModel";
import { Description } from "@/components/YhBox/Description";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useDictModel } from "../../../../base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { usePurchasePoModel } from "../../purchasePoModel";
import { debounce } from "lodash";
interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    purchasePoDetails: React.MutableRefObject<IYhFormRef | undefined>
}
// interface ITopType extends RouterParamType,React.MutableRefObject<IYhFormRef>{}
export const TopButs: FC<ITopType> = ({ id, mode, purchasePoDetails }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { setSelectedRowKeys,setDescRows,setSelectedRow } = usePurchasePoModel()
    const { detailAddForm, detailLookForm, detailEditForm, initForm, insertDetail, editDetail, Settle, resetAddCatch, getDetailEditOne, WhConfirm, setDetailAddForm, setDetailAddList } = usePurchasePoDetailsModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();
    const save = async () => {
        purchasePoDetails.current?.validateFields().then(async res => {
            if (mode == "add") {
                const resData = await insertDetail(res)
                if (resData) {
                    goBack();
                    // globalPrompt("message", { text: "新增成功", type: "success" });
                    globalPrompt("message", { text: Locale["Successfully added"], type: "success" });
                    resetAddCatch(mode);
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
            } else if (mode == "edit") {
                let { purchaseCode, id } = detailEditForm
                const resData = await editDetail({ ...res, purchaseCode, id })
                // resData == true && goBack() && globalPrompt("message", { text: "编辑成功", type: "success" })
                resData == true && goBack() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" });

            }
        })
    }
    const goBack = async () => {
        replaceNav(selectedNavId, "3-1")
    }
    const onSettle = async () => {
        let { purchaseCode, id } = detailEditForm
        let retData = await Settle({ purchaseCode, id })
        retData ? message.success("结算成功") && goBack() : message.error("结算失败")
    }
    const onWhConfirm = async () => {
        let { purchaseCode, id } = detailEditForm
        let retData = await WhConfirm({ purchaseCode, id })
        retData ? message.success("入库成功") && goBack() : message.error("入库失败")
    }
    const onRefresh = async () => {
        if (mode == 'add') {
            purchasePoDetails.current?.resetFields()
            setDetailAddForm(initForm)
            setDetailAddList([])

        } else if (mode == 'edit') {
            getDetailEditOne(id, mode)
        }
        // message.success("刷新成功")
        message.success(Locale["Successfully refreshed"])
    }
    const action = <>
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            // onClick={() => save()}
            onClick={debounce(() => { save() }, 900)}
        >{Locale["Save"]}</Button>}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goBack()}
        >{Locale["Back"]}</Button>
        {/* {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onSettle()}
        >结算</Button>}
        {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onWhConfirm()}
        >入库</Button>} */}
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onRefresh()}
        >{Locale["Refresh"]}</Button>}
    </>;

    const typeTitle = {
        "add": detailAddForm,
        "edit": detailEditForm,
        "look": detailLookForm,
    }

    const orderStatu: IDescription[] = [
        {
            label: Locale["Purchase Doc No."],//"采购单",
            value: typeTitle[mode]?.purchaseCode as string ?? Locale["Not yet"],
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: Locale["Status"],//"状态",
            // value: getTreeNodeName(typeTitle[mode]?.status as string) || Locale["Not yet"],
            value: (typeTitle[mode]?.status && (language == "zh-CN" ? getTreeNodeOne(typeTitle[mode]?.status as string)[0].name : getTreeNodeOne(typeTitle[mode]?.status as string)[0].nameEn as string)) ?? Locale["Not yet"],
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}